import {inject, Injectable} from '@angular/core';
import {firstValueFrom} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {Planificacion} from '@kilobytelab/types';
import {API_URL_TOKEN} from '../token';

@Injectable({
  providedIn: 'root'
})
export class ApiPlanifService {

  private http = inject(HttpClient);
  private apiUrl = inject(API_URL_TOKEN);

  /*** planificación ***/

  getPlanificacion(curso: string): Promise<Planificacion[]> {
    const url = `${this.apiUrl}planificacion/${curso}`;
    return firstValueFrom(this.http.get<Planificacion[]>(url))
  }
  savePlanif(curso: string, data: string): Promise<void> {
    const url = `${this.apiUrl}planificacion/${curso}`;
    return firstValueFrom(this.http.post<void>(url, {data: data}))
  }
  deletePlanif(curso: string): Promise<void> {
    const url = `${this.apiUrl}planificacion/${curso}`;
    return firstValueFrom(this.http.delete<void>(url))
  }

}
